"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProgressBarDesktop_1 = require("./ProgressBarDesktop");
exports.default = ProgressBarDesktop_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ProgressBar/ProgressBarDesktop/index.js
// module id = 532
// module chunks = 8